import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export const useFormatShelfLife = () => {
  const { t: tp } = useTranslation('product')

  // Преобразуем вход к числу
  const formatShelfLife = useCallback(
    (shelfLifeInput: number | string) => {
      const shelfLife =
        typeof shelfLifeInput === 'number'
          ? shelfLifeInput
          : parseFloat(shelfLifeInput)

      const shelfLifeRounded = Math.floor(shelfLife)

      if (shelfLifeRounded >= 24) {
        // Переводим часы в дни (целое число дней, округлённое вниз)
        const days = Math.floor(shelfLifeRounded / 24)

        if (days > 90) {
          // Если больше 90 дней — показываем в месяцах
          const months = Math.floor(days / 30)
          return `${months} ${tp('shelfLife.months')}`
        }

        return `${days} ${tp('shelfLife.days')}`
      }

      // Менее 24 часов — показываем часы (целое число)
      return `${shelfLifeRounded} ${tp('shelfLife.hours')}`
    },
    [ tp ],
  )

  return formatShelfLife
}
